import { Controller, useFormContext } from 'react-hook-form'

import { NumberInput } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'mileage'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {}

const MileageField = ({ isFieldReadOnly, isFieldMandatory }: Props) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext()

  const units = watch('units')
  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <NumberInput
          label={i18n.t('expenses_v2.forms.fields.mileage.label')}
          value={field.value}
          units={units}
          maxDecimals={2}
          placeholder={'0'}
          required={isFieldMandatory ?? false}
          disabled={isFieldReadOnly}
          locale={i18n.locale}
          onChange={(value) => {
            field.onChange(value)
          }}
          error={castError(errors?.mileage)}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(MileageField, FIELD_NAME))
